export default __webpack_public_path__ + "static/media/service.4e6773d6.jpg";